import React, {
  FC,
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  Animated,
  Image,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from 'react-native';
import {
  account_white,
  book_sports_facility_white,
  cart,
  club_services_white,
  dining_white,
  events_white,
  e_shop_white,
  home_white,
  logo,
  news_white,
  notices_white,
  search_white,
} from '../assets/base64';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../components/Button';
import { Text } from '../components/Text';
import { TextInput } from '../components/TextInput/TextInput';
import { MAX_WIDTH } from '../constants/platform';
import { STYLE_VARS } from '../constants/style-vars';
import { addBase64Prefix } from '../services/addBase64Prefix';
import { NavigationService } from '../services/navigation';
import { RootState } from '../services/redux/store';
import { FONTS } from '../constants';
import { Category } from '../types/woocommerce.types';
import { wooCommerceApi } from '../services/api/wooCommerceApi';
import { setEShopCategories } from '../services/redux/reducers/EShopCategorySlice';
import { Alert } from '../services/alert';
import { logout } from '../services/redux/reducers/AuthSlice';
import { API_URI } from '../constants/env';
import { setIsShowStart } from '../services/redux/reducers/SwitchECardSlice';

const lorem =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

const MenuItem: FC<{
  title: string;
  icon: any;
  size: number;
  body?: string;
  contents?: {
    title: string;
    onPress?: () => void;
    photo?: any;
  }[];
  active?: boolean;
  hasDropDown?: boolean;
  onPress?: () => void;
}> = memo(
  ({
    title,
    icon,
    size,
    hasDropDown = true,
    onPress,
    contents,
    body,
    active = false,
  }) => {
    const [isHover, setHover] = useState<boolean>(false);
    const [contentHover, setcontentHover] = useState<any>({});
    const progress = useRef(new Animated.Value(0)).current;
    const imageAnimate = useRef(new Animated.Value(0)).current;
    const { width } = useWindowDimensions();

    const handleMouseEnter = () => {
      setHover(true);
      Animated.timing(progress, {
        toValue: 1,
        duration: 500,
        useNativeDriver: false,
      }).start();
    };

    const handleMouseLeave = () => {
      setHover(false);
      Animated.timing(progress, {
        toValue: 0,
        duration: 0,
        useNativeDriver: false,
      }).start();
    };

    const handleMouseContentEnter = (content: any) => {
      setcontentHover(content);
      Animated.timing(imageAnimate, {
        toValue: 1,
        duration: 400,
        useNativeDriver: false,
      }).start();
    };

    const handleMouseContentLeave = () => {
      setcontentHover({});
      Animated.timing(imageAnimate, {
        toValue: 0,
        duration: 0,
        useNativeDriver: false,
      }).start();
    };
    return (
      <div
        style={{ display: 'flex', cursor: 'pointer' }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={(e) => {
          if (onPress) onPress();
        }}
      >
        <View
          style={{
            flexDirection: 'column',
            alignItems: 'center',
            marginRight: 15,
            marginLeft: 15,
            marginBottom: 2,
          }}
        >
          <Image
            source={icon}
            style={{
              width: 24,
              height: 24,
              resizeMode: 'contain',
              tintColor: 'white',
            }}
          />
          <Text style={{ color: 'white', fontSize: 12, marginTop: 3 }}>
            {title}
          </Text>
          {(isHover || active) && (
            <View
              style={{
                position: 'absolute',
                left: -20,
                right: -20,
                bottom: -4,
                height: 2,
                backgroundColor: '#d2232a',
              }}
            />
          )}
        </View>

        {hasDropDown && isHover && (
          <Animated.View
            style={{
              opacity: progress,
              position: 'absolute',
              width,
              left: 0,
              borderBottomLeftRadius: 20,
              borderBottomRightRadius: 20,
              top: 86,
              height: 300,
              backgroundColor: '#ffffff',
              shadowColor: '#000',
              shadowOffset: {
                width: 0,
                height: 2,
              },
              shadowOpacity: 0.5,
              shadowRadius: 3.84,
              elevation: 5,
            }}
          >
            <View
              style={{
                maxWidth: 1250,
                marginHorizontal: 'auto',
                width: '90%',
                flexDirection: 'row',
                paddingVertical: 50,
                alignItems: 'flex-start',
                gap: 20,
              }}
            >
              <View
                style={{
                  width: '30%',
                  maxWidth: 301,
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  marginRight: 20,
                }}
              >
                <Text
                  style={{
                    fontFamily: FONTS.IowanOldStyleBTRoman,
                    color: STYLE_VARS.textColor,
                    fontSize: 32,
                    textTransform: 'uppercase',
                    fontStyle: 'italic',
                  }}
                >
                  {title}
                </Text>
                <Text
                  numberOfLines={3}
                  style={{
                    fontFamily: FONTS.IowanOldStyleBTRoman,
                    marginTop: 10,
                    color: STYLE_VARS.fccDarkerGrey,
                    maxWidth: 250,
                    letterSpacing: 1,
                    fontSize: 12,
                    textTransform: 'uppercase',
                  }}
                >
                  {body}
                </Text>
                <View style={{ alignSelf: 'flex-start', marginTop: 20 }}>
                  <Button
                    textStyle={{
                      fontWeight: '400',
                    }}
                    style={STYLE_VARS.blueButton}
                    text="READ MORE"
                    onPress={() => {
                      if (onPress) onPress();
                    }}
                  />
                </View>
              </View>
              <View style={{ width: '30%', alignItems: 'flex-start' }}>
                {contents?.map((content) => (
                  <div
                    style={{ alignItems: 'flex-start' }}
                    onMouseEnter={() => {
                      handleMouseContentEnter(content);
                    }}
                    onMouseLeave={handleMouseContentLeave}
                    key={content.title}
                  >
                    <TouchableOpacity
                      key={content.title}
                      style={{ marginTop: 12 }}
                      onPress={() => {
                        if (content.onPress) {
                          content.onPress();
                          handleMouseLeave();
                          setHover(false);
                        }
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: FONTS.ArialMTBlack,
                          color:
                            content == contentHover
                              ? STYLE_VARS.textColor
                              : STYLE_VARS.fccDarkerGrey,
                          fontWeight: content == contentHover ? '500' : '400',
                          fontSize: 14,
                          letterSpacing: 1,
                          textTransform: 'uppercase',
                        }}
                      >
                        {content.title}
                      </Text>
                    </TouchableOpacity>
                  </div>
                ))}
              </View>
              <View style={{ width: '20%', alignItems: 'flex-start' }}>
                {contentHover.photo && (
                  <Animated.View style={{ opacity: imageAnimate }}>
                    <Image
                      source={contentHover.photo}
                      style={{
                        width: 200,
                        height: 150,
                        resizeMode: 'cover',
                      }}
                    />
                  </Animated.View>
                )}
              </View>
            </View>
          </Animated.View>
        )}
      </div>
    );
  }
);

const NavHeader: FC = () => {
  const { width } = useWindowDimensions();
  const margin = useMemo(
    () => Math.max(Math.min(width - 1150, 120), -70),
    [width]
  );
  const curRoute = useSelector((redux: RootState) => redux.route);
  const dispatch = useDispatch();
  const { categories } = useSelector(
    (state: RootState) => state.eShopCategoryReducer
  );

  const getCategories = useCallback(async () => {
    try {
      const res = await wooCommerceApi.get('products/categories', {
        per_page: 20,
        parent: 0,
      });
      dispatch(setEShopCategories(res.data));
    } catch (error: any) {
      console.log(error);
    }
  }, [dispatch]);

  useEffect(() => {
    getCategories();
  }, [getCategories]);
  const auth = useSelector((redux: RootState) => redux.authReducer);

  const HEADER_MENU = useMemo(() => {
    if (!auth.loggedin) return [];

    return [
      {
        title: 'MEMBER HOME',
        icon: addBase64Prefix(home_white),
        body: '',
        active:
          curRoute.name == 'Root' &&
          (curRoute.params == undefined || curRoute.params.screen == 'HomeTab')
            ? true
            : false,
        size: 30,
        hasDropDown: false,
        onPress: () => {
          NavigationService.push('Root', {
            screen: 'HomeTab',
          });
        },
      },
      {
        title: 'SPORTS',
        icon: addBase64Prefix(book_sports_facility_white),
        size: 30,
        active: ['Sports', 'CourtDetail'].includes(
          curRoute?.params?.params?.screen || ''
        ),
        body: 'A PLACE TO ENJOY SPORTS AND COMRADESHIP WITH FAMILY AND FRIENDS SINCE 1904.',
        contents: [
          {
            title: 'Facility Booking',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'Sports',
                  params: {
                    screen: 'Facility',
                  },
                },
              });
            },
            photo: {
              uri: 'https://kcc.org.hk/wp-content/uploads/2023/04/tENNIS-SQUARE.jpg',
            },
          },
          {
            title: 'Sports Coaching',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'Sports',
                  params: {
                    screen: 'Coaching',
                  },
                },
              });
            },
            photo: {
              uri: 'https://kcc.org.hk/wp-content/uploads/2022/11/imgpsh_fullsize_anim-11.jpg',
            },
          },
        ],
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'Sports',
              params: {
                screen: 'Facility',
              },
            },
          });
        },
      },
      {
        title: 'EVENTS',
        icon: addBase64Prefix(events_white),
        size: 30,
        active: ['EventList', 'EventDetail'].includes(
          curRoute?.params?.params?.screen || ''
        ),
        body: 'EXPLORE KCC’S LATEST NEWS, NOTICES AND SIGN UP TO UPCOMING EVENTS.',
        contents: [
          {
            title: 'Upcoming Events',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'EventList',
                  params: {
                    screen: 'Grid',
                  },
                },
              });
            },
            photo: {
              uri: 'https://kcc.org.hk/wp-content/uploads/2023/03/events123.jpg',
            },
          },
          // {
          //   title: 'Event Calendar',
          //   onPress: () => {
          //     NavigationService.push<'Root'>('Root', {
          //       screen: 'MenuTab',
          //       params: {
          //         screen: 'EventList',
          //         params: {
          //           screen: 'Calendar',
          //         },
          //       },
          //     });
          //   },
          //   photo: {
          //     uri: 'https://kcc.org.hk/wp-content/uploads/2023/03/events123.jpg',
          //   },
          // },
        ],
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'EventList',
              params: {
                screen: 'Grid',
              },
            },
          });
        },
      },
      {
        title: 'DINING',
        icon: addBase64Prefix(dining_white),
        size: 30,
        active: [
          'GrillRoom',
          'PrivateFunction',
          'DinningMenu',
          'DinningPromotion',
          'DinningPromotionDetail',
        ].includes(curRoute?.params?.params?.screen || ''),
        body: 'DISCOVER KCC’S DINING VENUE’S, VIEW OUR MENUS AND BOOK THE GRILL ROOM OR A PRIVATE FUNCTION.',
        contents: [
          {
            title: 'Dining Reservation',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'GrillRoom',
                },
              });
            },
            photo: {
              uri: 'https://kcc.org.hk/wp-content/uploads/2022/11/The-Grill-Room-dropdown-scaled.jpg',
            },
          },
          {
            title: 'Book Private Function',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'PrivateFunction',
                },
              });
            },
            photo: {
              uri: 'https://kcc.org.hk/wp-content/uploads/2023/04/pavilion-churva.jpg',
            },
          },
          {
            title: 'Dining Promotions',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'DinningPromotion',
                },
              });
            },
            photo: {
              uri: 'https://kcc.org.hk/wp-content/uploads/2023/04/DSCF4269.jpg',
            },
          },
          {
            title: 'Dining Menus',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'DinningMenu',
                },
              });
            },
            photo: {
              uri: 'https://kcc.org.hk/wp-content/uploads/2023/04/DSCF4459-1.jpg',
            },
          },
        ],
        onPress: () => {
          NavigationService.push('GrillRoom');
        },
      },
      {
        title: 'E-SHOP',
        icon: addBase64Prefix(e_shop_white),
        size: 28,
        body: lorem,
        active: [
          'EShopHomePage',
          'EShopCategoryPage',
          'EShopSubCategoryPage',
        ].includes(curRoute?.params?.params?.screen || ''),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'EShopHomePage',
            },
          });
        },
        contents: categories.map((category) => ({
          title: category.name,
          onPress: () => {
            NavigationService.push<'Root'>('Root', {
              screen: 'MenuTab',
              params: {
                screen: 'EShopCategoryPage',
                params: {
                  name: category.slug,
                },
              },
            });
          },
          photo: {
            uri: `${API_URI}/wp-content/uploads/2023/02/Banner-Photo.jpg`,
          },
        })),
      },
      {
        title: 'CLUB SERVICES',
        icon: addBase64Prefix(club_services_white),
        active: [
          'ServiceForm',
          'Feedback',
          'Survey',
          'ReciprocalClubs',
        ].includes(curRoute?.params?.params?.screen || ''),
        size: 28,
        body: lorem,
        contents: [
          {
            title: 'Services & Forms',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'ServiceForm',
                },
              });
            },
            photo: {
              uri: `${API_URI}/wp-content/uploads/2023/02/Banner-Photo.jpg`,
            },
          },
          // {
          //   title: 'Staff Contacts',
          //   onPress: () => {
          //   },
          //   photo: {
          //     uri: 'https://kcc.dev.bossdigitalasia.com/wp-content/uploads/2023/04/staff-4.3.jpg',
          //   },
          // },
          {
            title: 'Feedback',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'Feedback',
                },
              });
            },
            photo: {
              uri: 'https://www.shutterstock.com/image-vector/feedback-concept-illustration-idea-reviews-260nw-1470642089.jpg',
            },
          },
          {
            title: 'Survey',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'Survey',
                },
              });
            },
            photo: {
              uri: `${API_URI}/wp-content/uploads/2023/04/staff-4.3.jpg`,
            },
          },
          {
            title: 'Recriprocal Clubs',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'ReciprocalClubs',
                },
              });
            },
            photo: {
              uri: `${API_URI}/wp-content/uploads/2023/04/member-square.jpg`,
            },
          },
        ],
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'ServiceForm',
            },
          });
        },
      },
      {
        title: 'NEWS',
        icon: require('../assets/news-white.png'),
        active: [
          'ClubNews',
          'ClubNewDetail',
          'SportNews',
          'SportNewDetail',
        ].includes(curRoute?.params?.params?.screen || ''),
        size: 30,
        body: 'EXPLORE KCC’S LATEST NEWS, NOTICES AND SIGN UP TO UPCOMING EVENTS.',
        contents: [
          {
            title: 'Club News',
            onPress: () => {
              NavigationService.push<'Root'>('Root', {
                screen: 'MenuTab',
                params: {
                  screen: 'ClubNews',
                },
              });
            },
            photo: {
              uri: 'https://kcc.org.hk/wp-content/uploads/2023/04/KCC-News-thumbnail.png',
            },
          },
          {
            title: 'Sports News',
            onPress: () => {
              NavigationService.push('SportNews');
            },
            photo: {
              uri: 'https://kcc.org.hk/wp-content/uploads/2023/04/KCC-Notices-thumbnail.png',
            },
          },
        ],
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'ClubNews',
            },
          });
        },
      },
      {
        title: 'NOTICES',
        body: 'EXPLORE KCC’S LATEST NEWS, NOTICES AND SIGN UP TO UPCOMING EVENTS.',
        icon: require('../assets/notices.png'),
        active: ['Notices', 'NoticeDetail'].includes(
          curRoute?.params?.params?.screen || ''
        ),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'Notices',
              params: {
                screen: 'new',
              },
            },
          });
        },
        size: 28,
      },
    ];
  }, [curRoute, categories, auth.loggedin]);

  return (
    <View style={{ flexDirection: 'column', zIndex: 10 }}>
      <View style={{ backgroundColor: STYLE_VARS.primaryColor }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            maxWidth: MAX_WIDTH,
            width: '100%',
            alignSelf: 'center',
            padding: '4px 0',
          }}
        >
          <TouchableOpacity
            onPress={() => {
              NavigationService.push('Root', {
                screen: 'HomeTab',
              });
            }}
          >
            <Image
              source={{ uri: addBase64Prefix(logo) }}
              style={{ width: 80, height: 80, marginLeft: 20 }}
            />
          </TouchableOpacity>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginLeft: margin,
              alignItems: 'flex-end',
            }}
          >
            {HEADER_MENU.map((item, index) => (
              <MenuItem {...item} key={index} />
            ))}

            {auth.loggedin && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  marginRight: 20,
                  marginLeft: 30,
                }}
              >
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: 8,
                    marginRight: 12,
                  }}
                >
                  <TextInput
                    placeholder="SEARCH"
                    placeholderTextColor="#ffffff60"
                    style={{
                      color: '#ffffff',
                      borderBottomColor: 'white',
                      borderBottomWidth: 1,
                      fontSize: 12,
                      padding: 4,
                      width: 100,
                      marginRight: 4,
                    }}
                  />

                  <Image
                    source={{ uri: addBase64Prefix(search_white) }}
                    style={{ width: 14, height: 14 }}
                  />
                </View>

                <div
                  style={{
                    flexDirection: 'row',
                    alignItems: 'flex-end',
                    display: 'flex',
                  }}
                >
                  <MenuItem
                    title="CART"
                    icon={addBase64Prefix(cart)}
                    size={28}
                    hasDropDown={false}
                    key={'Cart'}
                    active={
                      curRoute?.params?.params?.screen === 'EShopCheckout'
                    }
                    onPress={() => {
                      NavigationService.push('Root', {
                        screen: 'MenuTab',
                        params: {
                          screen: 'EShopCheckout',
                        },
                      });
                    }}
                  />
                  <MenuItem
                    key={'MY ACCOUNT'}
                    title="MY ACCOUNT"
                    icon={addBase64Prefix(account_white)}
                    size={24}
                    hasDropDown={true}
                    active={
                      ['MyAccountTab', 'MyBookingsTab', 'MyOrdersTab'].includes(
                        curRoute.params?.screen || ''
                      ) ||
                      ['AccountStatememt', 'MyPreferences'].includes(
                        curRoute.name
                      )
                    }
                    onPress={() => {
                      NavigationService.push<'Root'>('Root', {
                        screen: 'MyAccountTab',
                      });
                    }}
                    contents={[
                      {
                        title: 'My profile',
                        onPress: () => {
                          NavigationService.push('Root', {
                            screen: 'MyAccountTab',
                          });
                        },
                      },
                      {
                        title: 'My Account Statement',
                        onPress: () => {
                          NavigationService.push('AccountStatememt');
                        },
                      },
                      {
                        title: 'My bookings',
                        onPress: () => {
                          // NavigationService.navigate('MyBookings')
                          NavigationService.push('Root', {
                            screen: 'MyBookingsTab',
                          });
                        },
                      },
                      {
                        title: 'My orders',
                        onPress: () => {
                          // NavigationService.navigate('MyOrders')
                          NavigationService.push('Root', {
                            screen: 'MyOrdersTab',
                          });
                        },
                      },
                      {
                        title: 'My Preferences',
                        onPress: () => {
                          NavigationService.push('MyPreferences');
                        },
                      },
                      {
                        title: 'Logout',
                        onPress: () => {
                          Alert.alert('Logout', 'You want to logout?', [
                            {
                              text: 'Ok',
                              onPress: () => {
                                dispatch(logout());
                                dispatch(setIsShowStart(false));
                                NavigationService.push('Login');
                              },
                            },
                            {
                              text: 'Cancel',
                              onPress: () => {},
                            },
                          ]);
                        },
                      },
                    ]}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </View>
    </View>
  );
};

export default NavHeader;
